import { alignVideoNarrative } from './pdp-video-alignment.js';
const { mountPdpVideo } = await import(document.querySelector('[data-pdp-video-player]')?.dataset.pdpVideoPlayer || new URL('./napoleon-ui.js',import.meta.url).href);
const marker = document.querySelector('[data-installation-video-map]');
if (marker) fetch(marker.dataset.installationVideoMap).then(r => {
  if (!r.ok) throw new Error('Installation video mapping unavailable');
  return r.json();
}).then(rows => {
  const row = rows.find(r => r.handles.includes(marker.dataset.productHandle));
  if (!row) return;
  const guide = document.createElement('div');
  guide.id = 'product-installation-video';
  guide.className = 'ho-installation-film';
  const title = document.createElement('h3');
  title.textContent = row.title;
  const host = document.createElement('div');
  host.className = 'ho-pdp-video';
  guide.append(title, host);
  let mounted = false;
  let brandMounted = false;
  const place = () => {
    const target = document.querySelector('.fire-pilot-content .fm-details > div:first-child, #documents:not([hidden]) > div:first-child, #planning:not([hidden]) > div:first-child');
    if (target && !target.contains(guide)) target.append(guide);
    if (target && !mounted) {
      mounted = true;
      mountPdpVideo(host, {youtubeId:row.videoId,title:row.title});
      alignVideoNarrative(host, target);
    }
    // Reuse the existing brand-image slot for the official brand film.
    const brand = document.querySelector('#outdoor-greatroom-root #brand .brand-picture');
    if (row.brand === 'The Outdoor GreatRoom Company' && brand && !brandMounted) {
      brandMounted = true;
      const brandHost = document.createElement('div');
      brandHost.className = 'ho-pdp-video';
      brandHost.id = 'product-brand-video';
      brand.replaceChildren(brandHost);
      mountPdpVideo(brandHost,{youtubeId:'QzWlTb8fAX4',title:'Bring Home Outside — The Outdoor GreatRoom Company'});
    }
  };
  place();
  new MutationObserver(place).observe(document.getElementById('MainContent'),{childList:true,subtree:true});
}).catch(error=>console.error(error));
